import PlayerFeature from './PlayerFeature';
import React, { useState } from 'react'
import SketchfabPlayerOnly from '../sketchfab/SketchfabPlayerOnly'
import {modelsList} from '../data'
import ContactBtn from './common/ContactBtn';
import { Row } from 'react-bootstrap';

function PlayerTop(){
  const [modelId, setModelId] = useState("43b3221efe52482da78121cd253bcc11")
  const [arId, setArId] = useState("43b3221efe52482da78121cd253bcc11")
  const topListFeature = ['Turn It','Spin It','Flip It','Look Inside']

    const handleModelData = (_data) => {
        setModelId(_data.modelId)
        setArId(_data.arPlayerId)
    }

    return(<>
        <div className="max-width-set">
            <br />
			<p className="top-title-0 text-center">
			3D Players
			</p>

			<p className="top-title-3 text-center my-1 mx-2 px-2 mx-md-5">
			Our customized <b>3D Player</b> includes a dashboard, complete with intuitive navigation tools and supporting materials. Paired with Augmented Reality, these tools empower users to manage spectacular views and perspectives that might not always be accessible in the classroom or field. 
			</p>

			<div className="carousel-top-video main-carousel-top">
			{/* <CarouselVideo/>           */}
			</div>
        
            <Row>
                <div className=" sketchfab-contain text-center d-flex justify-content-center">
                    <div className="max-width-set">
                        <p className=' mx-5  top-title-3 '>
                            <span className='fw-bold'>Choose your view: </span> Explode, Cut-away, Rotate, Animate, Annotate, Look-Inside, Look Side-by-Side. Turn it on, Slow it down, and even view in Augmented Reality.
                        </p>
                    </div>
                </div>
            </Row>
            
            <Row className='d-flex justify-content-center align-content-center'>
                <div className="card sketchfab-player-section py-2 px-2 px-md-4 py-md-3 max-width-set">
                    <div className="viewer-container card-body ratio ratio-16x9 shadow-5-strong">
                        <SketchfabPlayerOnly assetId={modelId} arPlayerId={arId} animationCollection={modelsList.find(model => model.modelId === modelId).animationCollection}  assetData={modelsList.find(model => model.modelId === modelId)} />
                    </div>
                    <div className='d-flex justify-content-center align-content-center pt-2 mt-1'>
                        <div className="row mx-2 mx-md-4 sketchfab-collection-selection shadow-2-soft p-2">
                            {modelsList &&
                                modelsList.map((data, index) => {
                                    return (
                                        <div className={`col-2 sketchfab-item-selection ${index == modelsList.findIndex(item => item.modelId === modelId) ? "sketchfab-item-selection-active" : ""}`} key={index}>
                                            <div className="container-player-sketchfab d-flex justify-content-center align-content-center cursor-pointer" onClick={() => handleModelData(data)}>
                                                <img
                                                    src={process.env.PUBLIC_URL + "Image/modal-player-thumbnail/" + data.img +".png"}
                                                    className="shadow-2-strong img-fluid sketchfab-img-button1"
                                                    alt="Boat on Calm Water"
                                                    
                                                />
                                                <div  className="hover-custom-tooltips text-center py-md-4 px-1">
                                                    <p style={{color:"white"}}>{data.name}</p>
                                                </div>
                                            </div>                   
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </Row>

            <Row className='py-md-4 my-md-4'>
                <ContactBtn/>
            </Row>

            <Row className='py-md-4 my-md-4'>
                <PlayerFeature/>
            </Row>

        </div>
    </>)
}

export default PlayerTop;